import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  askDelete: {
    id: 'app.components.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.OnsiteAddressCard.AddressRow.askDelete',
    defaultMessage:
      'Please save any changes to this stage prior to deleting an onsite address. Do you want to continue deleting the onsite address?',
  },
  deleteOnsiteAddress: {
    id: 'app.components.WorkflowEditor.components.WorkflowEditorContent.StageDetail.SchedulerStage.OnsiteAddressCard.AddressRow.deleteOnsiteAddress',
    defaultMessage: 'Delete Onsite Address',
  },
});
export default messages;
